export const GET_PAYMENT_SERVICE_CONF = "GET_PAYMENT_SERVICE_CONF";
export const SET_PAYMENT_SERVICE_CONF = "SET_PAYMENT_SERVICE_CONF";
export const PAYMENT_SERVICE_CONF = "PAYMENT_SERVICE_CONF";
export const SET_PAYMENT_SERVICE_DATA = "SET_PAYMENT_SERVICE_DATA";
export const SET_PAYMENT_SERVICE_DATA_RESULT =
  "SET_PAYMENT_SERVICE_DATA_RESULT";
export const PAYMENT_SERVICE_RESULT = "PAYMENT_SERVICE_RESULT";
export const SET_TELCEL_PREPAGO_PAYMENT_SERVICE_DATA =
  "SET_TELCEL_PREPAGO_PAYMENT_SERVICE_DATA";
export const TELCEL_PREPAGO_PAYMENT_SERVICE_DATA =
  "TELCEL_PREPAGO_PAYMENT_SERVICE_DATA";
export const GET_OCR_SCANNER = "GET_OCR_SCANNER";
export const SET_OCR_SCANNER = "SET_OCR_SCANNER";
export const OCR_SCANNER_DATA = "OCR_SCANNER_DATA";
export const SET_OCR_SCANNER_DATA = "SET_OCR_SCANNER_DATA";
export const GET_PAYMENT_SERVICE_CONTACTS = "GET_PAYMENT_SERVICE_CONTACTS";
export const SET_PAYMENT_SERVICE_CONTACTS = "SET_PAYMENT_SERVICE_CONTACTS";
export const PAYMENT_SERVICE_CONTACTS = "PAYMENT_SERVICE_CONTACTS";
export const SET_NUMBER_CONTACTS = "SET_NUMBER_CONTACTS";
export const SET_CONTACT_INFO = "SET_CONTACT_INFO";
export const SET_CREDIT_CARD_INFO = "SET_CREDIT_CARD_INFO";

export const GET_FAVORITE_CONTACTS = "GET_FAVORITE_CONTACTS";
export const GET_FAVORITE_CONTACTS_SUCESS = "GET_FAVORITE_CONTACTS_SUCESS";
export const GET_FAVORITE_CONTACTS_ERROR = "GET_FAVORITE_CONTACTS_ERROR";

export const ADD_CONTACT_TO_FAVORITES = "ADD_CONTACT_TO_FAVORITES";
export const ADD_CONTACT_TO_FAVORITES_SUCESS =
  "ADD_CONTACT_TO_FAVORITES_SUCESS";
export const ADD_CONTACT_TO_FAVORITES_ERROR = "ADD_CONTACT_TO_FAVORITES_ERROR";

export const DELETE_CONTACT_FROM_FAVORITES = "DELETE_CONTACT_FROM_FAVORITES";
export const GET_PARAMS_FROM_URL = "GET_PARAMS_FROM_URL";
export const GET_BUNDLE_VERSION_FROM_URL = "GET_BUNDLE_VERSION_FROM_URL";
export const GET_BUNDLE_ID_FROM_URL = "GET_BUNDLE_ID_FROM_URL";

/////////// favorite contacts

export const GET_RECENT_CONTACTS = "GET_RECENT_CONTACTS";
export const GET_RECENT_CONTACTS_SUCESS = "GET_RECENT_CONTACTS_SUCESS";
export const GET_RECENT_CONTACTS_ERROR = "GET_RECENT_CONTACTS_ERROR";

export const ADD_CONTACT_TO_RECENTS = "ADD_CONTACT_TO_RECENTS";
export const ADD_CONTACT_TO_RECENTS_SUCESS = "ADD_CONTACT_TO_RECENTS_SUCESS";
export const ADD_CONTACT_TO_RECENTS_ERROR = "ADD_CONTACT_TO_RECENTS_ERROR";

export const DELETE_CONTACT_FROM_RECENTS = "DELETE_CONTACT_FROM_RECENTS";

/// Telcel
export const GET_AMOUNT_OF_TELCEL_POSPAGO = "GET_AMOUNT_OF_TELCEL_POSPAGO";
export const GET_AMOUNT_OF_TELCEL_POSPAGO_SUCESS =
  "GET_AMOUNT_OF_TELCEL_POSPAGO_SUCESS";
export const GET_AMOUNT_OF_TELCEL_POSPAGO_ERROR =
  "GET_AMOUNT_OF_TELCEL_POSPAGO_ERROR";

export const GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT = "GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT";
export const GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT_SUCCESS = "GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT_SUCCESS";

/// user info

export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_INFO_SUCESS = "GET_USER_INFO_SUCESS";
export const GET_USER_INFO_ERROR = "GET_USER_INFO_ERROR";

/// payment methods

export const GET_PAYMENT_METHODS = "GET_PAYMENT_METHODS";
export const GET_PAYMENT_METHODS_SUCESS = "GET_PAYMENT_METHODS_SUCESS";
export const GET_PAYMENT_METHODS_ERROR = "GET_PAYMENT_METHODS_ERROR";

/// commission rules

export const GET_COMMISSION_RULES_SUCESS = "GET_COMMISSION_RULES_SUCESS";
export const GET_COMMISSION_INFO_ERROR = "GET_COMMISSION_INFO_ERROR";

export const SET_SELECTED_CHIP_VALUES = "SET_SELECTED_CHIP_VALUES";
export const SET_SELECTED_CHIP_VALUES_SUCESS =
  "SET_SELECTED_CHIP_VALUES_SUCESS";

export const GET_COMMISSION_INFO = "GET_COMMISSION_INFO";

export const GET_PLANS = "GET_PLANS";
export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const GET_PLANS_ERROR = "GET_PLANS_ERROR";
export const EXIST_CARD_SEARS = "EXIST_CARD_SEARS";
export const EXIST_CARD_SEARS_SUCCESS = "EXIST_CARD_SEARS_SUCCESS";
export const EXIST_CARD_SEARS_ERROR = "EXIST_CARD_SEARS_ERROR";

export const GET_PLANS_CARD_SEARS = "GET_PLANS_CARD_SEARS";
export const GET_PLANS_CARD_SEARS_SUCCESS = "GET_PLANS_CARD_SEARS_SUCCESS";

export const GET_COORDINATES = "GET_COORDINATES";
export const SET_COORDINATES = "SET_COORDINATES";
export const GET_TRACK_ID = "GET_TRACK_ID";
export const GET_TRACK_ID_SUCCESS = "GET_TRACK_ID_SUCCESS";
export const SET_TRACK_DATA = "SET_TRACK_DATA";
export const SET_TRACK_DATA_SUCCESS = "SET_TRACK_DATA_SUCCESS";
export const SET_TRACK_STEPS = "SET_TRACK_STEPS";
export const SET_TRACK_STEPS_SUCCESS = "SET_TRACK_STEPS_SUCCESS";

export const GET_ACTIVE_FROM_URL = "GET_ACTIVE_FROM_URL";
export const GET_CAN_ENCRYPT = "GET_CAN_ENCRYPT";
export const GET_CAN_MULTIANALYTICS = "GET_CAN_MULTIANALYTICS";
export const CAN_GET_TOKEN_COMPLETE = "CAN_GET_TOKEN_COMPLETE";
export const GET_CAN_BARS_VISIBILITY = "GET_CAN_BARS_VISIBILITY";
export const CAN_REGISTER_EMAIL = "CAN_REGISTER_EMAIL";
export const GET_CAN_MANAGE_FAVORITES = "GET_CAN_MANAGE_FAVORITES";
export const GET_CAN_FAVORITE_TOOLTIP = "GET_CAN_FAVORITE_TOOLTIP";
export const CAN_PAYMENT_REMINDER = "CAN_PAYMENT_REMINDER";
export const SEND_SERVICEID = "SEND_SERVICEID";
export const GET_HAS_CREDIT_FROM_URL = "GET_HAS_CREDIT_FROM_URL";
export const GET_PHONE_NUMBER = "GET_PHONE_NUMBER";
export const ORIGIN_OF_PAYMENT = "ORIGIN_OF_PAYMENT";
export const EXECUTE_TAGGEO = "EXECUTE_TAGGEO";
export const SEND_ISCLAROSOCIO = "SEND_ISCLAROSOCIO";

export const GET_MESSENGER_SERVICE = "GET_MESSENGER_SERVICE"
export const GET_MESSENGER_SERVICE_SUCCESS = "GET_MESSENGER_SERVICE_SUCCESS"
export const GET_MESSENGER_SERVICE_ERROR = "GET_MESSENGER_SERVICE_ERROR"
export const GET_MESSAGES_TOKENIZATION = "GET_MESSAGES_TOKENIZATION";
export const GET_MESSAGES_ANON_FLOW_SUCCESS = "GET_MESSAGES_ANON_FLOW_SUCCESS"
export const GET_MESSENGER_SERVICE_SEARS = "GET_MESSENGER_SERVICE_SEARS"
export const GET_MESSENGER_SERVICE_SEARS_SUCCESS = "GET_MESSENGER_SERVICE_SEARS_SUCCESS"
export const GET_MESSENGER_SERVICE_SEARS_ERROR = "GET_MESSENGER_SERVICE_SEARS_ERROR"
export const SHOW_NEW_OFFER_TELCEL = "SHOW_NEW_OFFER_TELCEL"
export const SHOW_CAN_COOKIES = "SHOW_CAN_COOKIES"
export const GET_TELCEL_LINE_INFORMATION = "GET_TELCEL_LINE_INFORMATION"
export const GET_TELCEL_LINE_INFORMATION_SUCCESS = "GET_TELCEL_LINE_INFORMATION_SUCCESS"
export const GET_TELCEL_LINE_INFORMATION_ERROR = "GET_TELCEL_LINE_INFORMATION_ERROR"
export const SET_PAYMENT_METHOD  = "SET_PAYMENT_METHOD";
export const GET_PAYMENT_AMOUNT_FROM_URL = "GET_PAYMENT_AMOUNT_FROM_URL";
export const GET_PRODUCT_ID_FROM_URL = "GET_PRODUCT_ID_FROM_URL";
export const SET_CODE_ERROR= "SET_CODE_ERROR"
export const GET_CODE_ERROR = "GET_CODE_ERROR"
export const SET_RELOAD_INFO_AFTER_ADDING_CARD = "SET_RELOAD_INFO_AFTER_ADDING_CARD";
export const SET_IS_ANONIMOUS = "SET_IS_ANONIMOUS"
export const SET_IS_TEMPORAL_CLARO_ID = "SET_IS_TEMPORAL_CLARO_ID"
export const SET_ADD_CARD_FORM_DATA = "SET_ADD_CARD_FORM_DATA";
export const GET_APP_SYNC = "GET_APP_SYNC"
export const GET_APP_SYNC_SUCCESS = "GET_APP_SYNC_SUCCESS"
export const GET_APP_SYNC_ERROR = "GET_APP_SYNC_ERROR"
export const TOKENIZATION_ON = "TOKENIZATION_ON"
export const SET_ADVANCEMT_PAY_METHOD = "SET_ADVANCEMT_PAY_METHOD";
export const SET_SHOW_ADVANCEMT_MINI_BANNER = "SET_SHOW_ADVANCEMT_MINI_BANNER";
export const GET_GO_TO_MICROAPPADELANTO = "GET_GO_TO_MICROAPPADELANTO";
export const SET_IS_CONTAINER_TELCEL = "SET_IS_CONTAINER_TELCEL";
export const DELETE_ALL_CARDS = "DELETE_ALL_CARDS";
export const SET_CVV_FOR_ANONIMOUS = "SET_CVV_FOR_ANONIMOUS";
export const SET_SHOW_LOADER_ON_DOUBLE_BACK = "SET_SHOW_LOADER_ON_DOUBLE_BACK";
export const CAN_GET_APPSYNC = "CAN_GET_APPSYNC";
export const SET_START_EVENT_LOGIN_IS_OVER = "SET_START_EVENT_LOGIN_IS_OVER";
export const SET_START_EVENT_ONBOARDING_IS_OVER = "SET_START_EVENT_ONBOARDING_IS_OVER";
export const SET_BUNDLE_PARAMS_FROM_URL = "SET_BUNDLE_PARAMS_FROM_URL"

export const SET_TOKENIZATION_CARD = "SET_TOKENIZATION_CARD";
export const SET_NUMBER_FROM_AGENDA = "SET_NUMBER_FROM_AGENDA";
export const SET_CAN_CHECKINFORMATION = "SET_CAN_CHECKINFORMATION";
export const SET_SNACKBAR_SUCCESS = "SET_SNACKBAR_SUCCESS";
export const LOADING_TOKENIZATION_CARD = "LOADING_TOKENIZATION_CARD";
export const ORIGIN_PARAM = "ORIGIN_PARAM";
export const GET_CAN_SCANNER = "GET_CAN_SCANNER";
export const GET_CAN_TAPTOAPP = "GET_CAN_TAPTOAPP";
export const GET_TAPTOAPP_PARAMS = "GET_TAPTOAPP_PARAMS";
export const GET_VERIFY_NFC = "GET_VERIFY_NFC";
export const GET_RESPONSE_READING_NFC = "GET_RESPONSE_READING_NFC";
export const SET_PAYMENT_METHODS_LOADED = "SET_PAYMENT_METHODS_LOADED";
export const SET_SHOW_TERMS_IN_FORM = "SET_SHOW_TERMS_IN_FORM";
export const SET_UNIFICATION_FLOW = "SET_UNIFICATION_FLOW";
export const GET_PROMINENT_DATE = "GET_PROMINENT_DATE";

export const SET_CAN_R1 = "SET_CAN_R1"
export const SET_CAN_R1_SUCCESS = "SET_CAN_R1_SUCCESS"

export const SET_CAN_GET_PROFILE = "SET_CAN_GET_PROFILE";
export const GET_PHONE_PROFILE = "GET_PHONE_PROFILE"
export const GET_PHONE_PROFILE_SUCCESS = "GET_PHONE_PROFILE_SUCCESS"
export const GET_PHONE_PROFILE_ERROR = "GET_PHONE_PROFILE_ERROR"

export const URL_FLAGS = "URL_FLAGS"
export const OPEN_PAY_METHOD_MODAL = "OPEN_PAY_METHOD_MODAL"
export const OPEN_FLUX_ADD_CARD = "OPEN_FLUX_ADD_CARD"
export const CAN_ADVANCE_MEGAS = "CAN_ADVANCE_MEGAS";

export const CHECK_BALANCE_N2 = "CHECK_BALANCE_N2";
export const SET_CHECK_BALANCE_N2_BALANCE = "SET_CHECK_BALANCE_N2_BALANCE";
export const CAN_CHECK_BALANCE_N2 = "CAN_CHECK_BALANCE_N2";
export const GET_BALANCE_FROM_HOME = "GET_BALANCE_FROM_HOME";

export const setStartEventLoginIsOver = (value) => ({
  type: SET_START_EVENT_LOGIN_IS_OVER,
  startEventLoginIsOver: value
});

export const setStartEventOnboardingIsOver = (value) => ({
  type: SET_START_EVENT_ONBOARDING_IS_OVER,
  startEventOnboardingIsOver: value
});

export const setShowLoaderOnDoubleBack = (value) => ({
  type: SET_SHOW_LOADER_ON_DOUBLE_BACK,
  payload: value
});

export const setCvvForAnonimous = (value) => ({
  type: SET_CVV_FOR_ANONIMOUS,
  payload: value
});

export const setIsContainerTelcel = (data) => ({
    type: SET_IS_CONTAINER_TELCEL,
    payload: data
  });

export const setAddCardFormData = (data) => ({
  type: SET_ADD_CARD_FORM_DATA,
  payload: data
});

export const setIsAnonimous = (value) => ({
  type: SET_IS_ANONIMOUS,
  payload: value
});

export const setIsTemporalClaroId = (value) => ({
  type: SET_IS_TEMPORAL_CLARO_ID,
  payload: value
});

export const setReloadInfoAfterAddingCard = (value) => ({
  type: SET_RELOAD_INFO_AFTER_ADDING_CARD,
  payload: value
});

export const getPaymentServiceConf = () => ({
  type: GET_PAYMENT_SERVICE_CONF,
});

export const setPaymentServiceConf = (data) => ({
  type: SET_PAYMENT_SERVICE_CONF,
  payload: data,
});

export const setPaymentServiceData = (data) => ({
  type: SET_PAYMENT_SERVICE_DATA,
  payload: data,
});

export const setPaymentServiceDataResult = (data) => ({
  type: SET_PAYMENT_SERVICE_DATA_RESULT,
  payload: data,
});

export const setTelcelPrepagoPaymentServiceData = (data) => ({
  type: SET_TELCEL_PREPAGO_PAYMENT_SERVICE_DATA,
  payload: data,
});

export const getOCRScanner = (isClaroPartner, logo, maxlength, format, regexAndroid, regexIos, aspectratio, orientation) => {
  return {
    type: GET_OCR_SCANNER,
    isClaroPartner,
    logo,
    maxlength,
    format,
    regexAndroid, 
    regexIos,
    aspectratio,
    orientation
  };
};

export const setNumberContact = (data) => ({
  type: SET_NUMBER_CONTACTS,
  payload: data,
});

export const setNumberFromAgenda = (numberFromAgenda) => ({
  type: SET_NUMBER_FROM_AGENDA,
  payload: numberFromAgenda
});

export const setContactInfo = (contactInfo) => ({
  type: SET_CONTACT_INFO,
  contactInfo,
});

export const setCreditCardInfo = (cardInfo) => ({
  type: SET_CREDIT_CARD_INFO,
  cardInfo,
});

export const setOCRScannerData = (data) => ({
  type: SET_OCR_SCANNER_DATA,
  payload: data,
});

export const getPaymentContacts = () => {
  return {
    type: GET_PAYMENT_SERVICE_CONTACTS,
  };
};

export const getFavoriteContacts = (serviceId) => ({
  type: GET_FAVORITE_CONTACTS,
  serviceId,
});

export const getFavoriteContactsSucess = (favoriteContacts) => ({
  type: GET_FAVORITE_CONTACTS_SUCESS,
  favoriteContacts,
});

export const getFavoriteContactsError = (e) => ({
  type: GET_FAVORITE_CONTACTS_ERROR,
  error: e,
});

export const setPaymentServiceContacts = (data) => ({
  type: SET_PAYMENT_SERVICE_CONTACTS,
  payload: data,
});

export const addContactToFavorites = (contact, serviceId) => ({
  type: ADD_CONTACT_TO_FAVORITES,
  contact,
  serviceId,
});

export const addContactToFavoritesSucess = () => ({
  type: ADD_CONTACT_TO_FAVORITES_SUCESS,
});

export const addContactToFavoritesError = (err) => ({
  type: ADD_CONTACT_TO_FAVORITES_ERROR,
  error: err,
});

export const deleteContactFromFavorites = (contact, serviceId) => ({
  type: DELETE_CONTACT_FROM_FAVORITES,
  contact,
  serviceId,
});

export const getRecentContacts = (serviceId) => {
  return {
    type: GET_RECENT_CONTACTS,
    serviceId,
  };
};

export const getRecentContactsSucess = (recentContacts) => ({
  type: GET_RECENT_CONTACTS_SUCESS,
  recentContacts,
});

export const getRecentContactsError = (e) => ({
  type: GET_RECENT_CONTACTS_ERROR,
  error: e,
});

export const addContactToRecents = (contact, serviceId) => ({
  type: ADD_CONTACT_TO_RECENTS,
  contact,
  serviceId,
});

export const addContactToRecentsSucess = () => ({
  type: ADD_CONTACT_TO_RECENTS_SUCESS,
});

export const addContactToRecentsError = (err) => ({
  type: ADD_CONTACT_TO_RECENTS_ERROR,
  error: err,
});

export const deleteContactFromRecents = (contact, serviceId) => ({
  type: DELETE_CONTACT_FROM_RECENTS,
  contact,
  serviceId,
});

/// Telcel

export const getAmountOfTelcelPospago = (telephoneNumber, serviceId, needsDelay = false) => ({
  type: GET_AMOUNT_OF_TELCEL_POSPAGO,
  telephoneNumber,
  serviceId,
  needsDelay
});

export const getAmountOfTelcelPospagoSucess = (amountTelcelPospago) => ({
  type: GET_AMOUNT_OF_TELCEL_POSPAGO_SUCESS,
  amountTelcelPospago,
});

export const getAmountOfTelcelPospagoError = (e) => ({
  type: GET_AMOUNT_OF_TELCEL_POSPAGO_ERROR,
  errorCheckBalance: e,
});

export const getScheduleTelcelBillPaymentContract = (
  bank,
  maximumAmount,
  minimumAmount,
  periodicity,
  product,
  providerService
) => ({
  type: GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT,
  bank,
  maximumAmount,
  minimumAmount,
  periodicity,
  product,
  providerService
})

export const getScheduleTelcelBillPaymentContractSuccess = (scheduleTecelContract) => ({
  type: GET_SCHEDULE_TELCEL_BILL_PAYMENT_CONTRACT_SUCCESS,
  scheduleTecelContract
})

/// user info

export const getUserInfo = () => ({
  type: GET_USER_INFO,
});

export const getUserInfoSucess = (userInfo) => ({
  type: GET_USER_INFO_SUCESS,
  userInfo,
});

export const getUserInfoError = (error) => ({
  type: GET_USER_INFO_ERROR
});

/// payment methods

export const getPaymentMethods = (serviceId, isClaroPartner) => ({
  type: GET_PAYMENT_METHODS,
  serviceId,
  isClaroPartner
});

export const getPaymentMethodsSucess = (paymentMethods) => ({
  type: GET_PAYMENT_METHODS_SUCESS,
  paymentMethods,
});

export const getPaymentMethodsError = (e) => ({
  type: GET_PAYMENT_METHODS_ERROR,
  errorPaymentMethods: e,
});

export const getCommissionRulesSucess = (commissionRules) => ({
  type: GET_COMMISSION_RULES_SUCESS,
  commissionRules,
});

export const getCommissionInfoError = (commissionInfoError) => ({
  type: GET_COMMISSION_INFO_ERROR,
  commissionInfoError,
});

export const setSelectedChipValues = (productId, amountValue) => ({
  type: SET_SELECTED_CHIP_VALUES,
  productId,
  amountValue,
});

export const setSelectedChipValuesSucess = (selectedChipValues) => ({
  type: SET_SELECTED_CHIP_VALUES_SUCESS,
  selectedChipValues,
});

export const getCommissionInfo = (
  serviceId,
  merchantId,
  amount,
  isClaroPay,
  cardId,
  sdkVersion,
  isClaroPartner,
  trackId,
  referenceMsisdn
) => ({
  type: GET_COMMISSION_INFO,
  serviceId,
  merchantId,
  amount,
  isClaroPay,
  cardId,
  sdkVersion,
  isClaroPartner,
  trackId,
  referenceMsisdn,
});

export const getPlans = (serviceId, planType) => ({
  type: GET_PLANS,
  serviceId,
  planType,
});

export const getPlansSuccess = (plans) => ({
  type: GET_PLANS_SUCCESS,
  plans,
});

export const getPlansError = (errorPlans) => ({
  type: GET_PLANS_ERROR,
  errorPlans,
});

export const existCardSears = (cardNumber, serviceId) => ({
  type: EXIST_CARD_SEARS,
  cardNumber,
  serviceId,
});

export const existCardSearsSuccess = (existCardSears) => ({
  type: EXIST_CARD_SEARS_SUCCESS,
  existCardSears,
});

export const existCardSearsError = (errorExistCardSears) => ({
  type: EXIST_CARD_SEARS_ERROR,
  errorExistCardSears,
});

export const getPlansCardSears = (cardSearsNumber, serviceId) => ({
  type: GET_PLANS_CARD_SEARS,
  cardSearsNumber,
  serviceId,
});

export const getPlansCardSearsSuccess = (plansCardSears) => ({
  type: GET_PLANS_CARD_SEARS_SUCCESS,
  plansCardSears,
});

export const coordinatesGetSuccess = () => {
  return {
    type: GET_COORDINATES,
  };
};

export const setCoordinates = (data) => ({
  type: SET_COORDINATES,
  coordinates: data,
});

export const getTrackId = () => {
  return {
    type: GET_TRACK_ID,
  };
};

export const getTrackIdSuccess = (trackId) => ({
  type: GET_TRACK_ID_SUCCESS,
  trackId,
});

export const setTxDataSuccess = (trackTxId) => ({
  type: SET_TRACK_DATA,
  trackTxId,
});

export const setTrackDataSuccess = () => ({
  type: SET_TRACK_DATA_SUCCESS,
});

export const setTrackSteps = (trackTxId, step) => ({
  type: SET_TRACK_STEPS,
  trackTxId,
  step,
});

export const setTrackStepsSuccess = (value) => ({
  type: SET_TRACK_STEPS_SUCCESS,
  value,
});


export const executeTaggeo = (params, isMultiAnalytics) => ({
  type: EXECUTE_TAGGEO,
  params,
  isMultiAnalytics,
});

export const getMessengerService = (flux, code) => ({
  type: GET_MESSENGER_SERVICE,
  flux,
  code,
});

export const getMessengerServiceSuccess = (messages) => ({
  type: GET_MESSENGER_SERVICE_SUCCESS,
  messages
});

export const getMessengerServiceError = (e) => ({
  type: GET_MESSENGER_SERVICE_ERROR,
  error: e.error
});

export const getMessagesTokenizationSuccess = (messagesTokenization) => ({
  type: GET_MESSAGES_TOKENIZATION,
  messagesTokenization,
});

export const getMessagesAnonFlowSuccess = (messagesAnonymousFlow) => ({
  type: GET_MESSAGES_ANON_FLOW_SUCCESS,
  messagesAnonymousFlow
})

export const getMessengerServiceSears = (flux, code) => ({
  type: GET_MESSENGER_SERVICE_SEARS,
  flux,
  code,
});

export const getMessengerServiceSearsSuccess = (searsMessages) => ({
  type: GET_MESSENGER_SERVICE_SEARS_SUCCESS,
  searsMessages
});

export const getMessengerServiceSearsError = (e) => ({
  type: GET_MESSENGER_SERVICE_SEARS_ERROR,
  error: e.error
});

export const getTelcelLineInformation = () => ({
  type: GET_TELCEL_LINE_INFORMATION
});

export const getTelcelLineInformationSuccess = (lineTelcelInformation) => ({
  type: GET_TELCEL_LINE_INFORMATION_SUCCESS,
  lineTelcelInformation,
});

export const getTelcelLineInformationError = (error) => ({
  type: GET_TELCEL_LINE_INFORMATION_ERROR,
  error,
});

export const setPaymentMethod = (paymentMethodInfo) => ({
  type: SET_PAYMENT_METHOD,
  payload: paymentMethodInfo
});

export const setCodeError = (codeError) => ({
  type: SET_CODE_ERROR,
  codeError
});

export const getAppSync = () => ({
  type: GET_APP_SYNC
});

export const getAppSyncSuccess = (appSyncValues) => ({
  type: GET_APP_SYNC_SUCCESS,
  appSyncValues: appSyncValues
});

export const tokenizationOn = (tokenizationOn) => ({
  type: TOKENIZATION_ON,
  tokenizationOn
});

export const getAppSyncError = (error) => ({
  type: GET_APP_SYNC_ERROR,
  error
});

export const setAdvancementPayMethod = (value) => ({
  type: SET_ADVANCEMT_PAY_METHOD,
  payload: value
});

export const setShowAdvancementMiniBanner = (value) => ({
  type: SET_SHOW_ADVANCEMT_MINI_BANNER,
  payload: value
});

export const deleteAllCards = (tokenFull) => ({
  type: DELETE_ALL_CARDS,
  tokenFull
})


export const setTokenizationCard = (tokenizationCard) => ({
  type: SET_TOKENIZATION_CARD,
  payload: tokenizationCard
});

export const setSnackBarSuccess = (value) => ({
	type: SET_SNACKBAR_SUCCESS,
	payload: value
});

export const setLoadingTokenizationCard = (isLoading) => ({
  type: LOADING_TOKENIZATION_CARD,
  payload: isLoading
});

export const setCanCheckInformation = (value) => ({
	type: SET_CAN_CHECKINFORMATION,
	payload: value
});

export const setVerifyNfc = (verifyNFC) => ({
  type: GET_VERIFY_NFC,
  verifyNFC: verifyNFC
});
export const setResponseReadingNfc = (responseReadingNFC) => ({
  type: GET_RESPONSE_READING_NFC,
  responseReadingNFC: responseReadingNFC
});
export const setPaymentMethodsLoaded = (value) => ({
	type: SET_PAYMENT_METHODS_LOADED,
	payload: value
});

export const setShowTermsInForm = (value) => ({
	type: SET_SHOW_TERMS_IN_FORM,
	payload: value
})

export const setCanR1Success = (payload) => ({
  type: SET_CAN_R1_SUCCESS,
  payload
})
export const setUnificationFlow = (value) => ({
  type: SET_UNIFICATION_FLOW,
  unificationFlow: value
})
export const setCanGetProfile = (value) => ({
	type: SET_CAN_GET_PROFILE,
	payload: value
});
export const getPhoneProfile = (msisdn) => ({
  type: GET_PHONE_PROFILE,
  msisdn
})

export const getPhoneProfileSuccess = (phoneProfile) => ({
  type: GET_PHONE_PROFILE_SUCCESS,
  phoneProfile
})

export const getPhoneProfileError = (error) => ({
  type: GET_PHONE_PROFILE_ERROR,
  error
})

export const setOpenPayMethodModal = (value) => ({
  type: OPEN_PAY_METHOD_MODAL,
  payload: value 
})

export const setOpenFluxAddCard = (value) => ({
  type: OPEN_FLUX_ADD_CARD,
  payload: value 
})
export const checkBalanceN2 = (requestId) => ({
  type: CHECK_BALANCE_N2,
  requestId
});
export const setCheckBalanceN2Balance = (payload) => ({
  type: SET_CHECK_BALANCE_N2_BALANCE,
  payload
});
export const getBalanceFromHome = (payload) => ({
  type: GET_BALANCE_FROM_HOME,
  payload
});